import {connect} from "react-redux"
import {createSelector} from "reselect"
import {FacetState} from "../../models/FacetsState"
import {LINK} from "../../config/constants"
import State from "../../models/State"
import {selectHasPreviousPage} from "../../ducks/search"

const selectFacets = (state: State) => state.search.facets
const selectStructuredBrowsingChipsToLoadLimit = (state: State) => state.search.structuredBrowsingChipsToLoadLimit

const makeSelectFacets = createSelector(
    [selectFacets, selectStructuredBrowsingChipsToLoadLimit],
    (facets, structuredBrowsingChipsToLoadLimit) => {
        const categoryFacets: FacetState[] = Object.keys(facets)
            .filter(facetName => facetName.startsWith(LINK))
            .map(facetName => facets[facetName])
            .slice(0, structuredBrowsingChipsToLoadLimit)

        return categoryFacets
    },
)

export const mapStateToProps = (state: State) => {
    const {enableStructuredBrowsing} = state.search
    const categoryFacets = makeSelectFacets(state)

    const hasStructuredBrowsing =
        enableStructuredBrowsing && categoryFacets.length > 0 && categoryFacets[0].u !== undefined

    return {
        enableSearchBannerTemplating: state.search.enableSearchBannerTemplating,
        json: state.search?.searchBannerJson,
        siteUrl: state.request.siteUrl,
        hasPreviousPage: selectHasPreviousPage(state),
        hasStructuredBrowsing,
        urlIsSaleOrClearance: state.request.urlIsSaleOrClearance,
    }
}

export default connect(mapStateToProps)
